import React from 'react'
import Reflux from 'reflux'
import BankStore from '../../../store/bankstore'
import i18 from '../../../i18'
import BankHelper from '../../../helpers/bankHelper'
import PATH from '../../../config/dev'
import api from '../../../source/api'
import {Link} from 'react-router-dom'
import NotificationSystem from "react-notification-system";
import User from "../../../helpers/user";

class DownloadXml extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            downloadButtonClicked: false,
            insuficientcredit: false,
            step: 4,
            downloadUrl: '',
            downloadFileName: '',
            loading: true,
            company_id: props.location.match.params.id,
            hasError: false,
        }
        this.store = BankStore
    }

    _addNotification = (msg, type, time = 10) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    componentDidMount = () => {
        let configs;

        switch (this.state.bank.upload.company.accountant_program_id) {
            case 1:
                configs = BankHelper.getConfigsKontir(this.state.bank.upload);
                break;
            case 3:
                configs = BankHelper.getConfigsRlb(this.state.bank.upload);
                break;
            default:
                configs = {};
        }
        let payload = {
            company_id: this.state.company_id,

            files: BankHelper.getFileNames(),
            vszItems: this.props.dataVszItems,
            processed: this.props.dataProcessed,
            unprocessed: this.props.dataUnprocessed,
            paired: this.props.dataPaired,
            unpaired: this.props.dataUnpaired,
            configs: configs,
            exchange: BankHelper.getExchangeData()
        }

        payload.configs.company_id = this.state.company_id
        api.post('bank/pairing/process', payload)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.url && response.data.message === 'INSUFFICIENT_BALANCE') {
                        this.setState({
                            insuficientcredit: true,
                            loading: false
                        });
                    } else {
                        this.setState({
                            downloadFileName: response.data.url,
                            loading: false,
                            downloadUrl: PATH.ENDPOINT_BASE_URL + 'bank/' + this.state.company_id + '/download'
                                + '?api_token=' + User.requireUser().auth_key
                                + '&name=' + response.data.url,
                        })
                    }
                } else {
                    this.setState({loading: false})
                    this._addNotification('Kimeneti fájl generelásáa közben hiba törtétn.', 'error')
                }
            })
            .catch((err) => {
                this.setState({
                    loading: false,
                    hasError: true
                });
                if (err.response.data.message) {
                    this._addNotification(err.response.data.message, 'error');
                } else {
                    this._addNotification(err.response.data.error.message, 'error');
                }
            })
    };

    downloadXml = () => {
        this.props.hideStepsMenu()
        this.setState({downloadButtonClicked: true})
        window.open(this.state.downloadUrl);
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="col-12" id='bank-download'>
                    <h4>{i18.COMMON._processingPleaseWait}</h4>
                </div>
            )
        }

        return (
            <div className="col-12" id='bank-download'>
                <h4>{i18.COMMON._processedSuccessfully}</h4>
                <br/>
                <div className={!this.state.insuficientcredit && !this.state.hasError ? 'text-center' : 'd-none'}>
                    {!this.state.downloadButtonClicked
                        ? <a onClick={() => this.downloadXml()} className='green-btn uppercase'>kimeneti fájl letöltés</a>
                        : <a className='green-btn uppercase disabled'>kimeneti fájl letöltés</a>}
                    <div>
                        <br/>
                        <br/>
                        <Link to="/" className={!this.state.downloadButtonClicked ? 'd-none' : ''}>Új feldolgozás indítása</Link>
                    </div>
                </div>
                <div className={this.state.hasError ? 'text-center' : 'd-none'}>
                    <p>
                        Hiba lépett fel a feldolgozá során.<br/>
                        Kérjük próbálja meg ismét a folyamatot.<br/>
                        Amennyiben még mindig nem sikerült letölteni a kimenetet, kérjük jelezze a kapcsolattartójánál.
                    </p>

                    <Link className='green-btn uppercase'
                          to={'/start/bank/' + this.state.company_id}
                          onClick={() => window.location.reload()}
                    >Vissza az első lépésre</Link>


                </div>
                <div className={this.state.insuficientcredit ? 'text-center' : 'd-none'}>
                    <h1 className='insufficinet-balance'>Önnek nincs elegendő egyenlege a kimeneti fájlok letöltéséhez. <br/> Kérjük töltse fel egyenlegét.</h1>
                    <div className='text-center margin-top-30'>
                        <Link to='/payment-start' className='green-btn uppercase'>Egyenleg feltöltése</Link>
                    </div>
                </div>
                <br/>
                <br/>
                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default DownloadXml


// WEBPACK FOOTER //
// ./src/components/bank/steps/downloadxml.js